<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <el-button size="small" @click="addSlice" type="primary"
          >添加充值优惠</el-button
        >
      </div>
      <el-radio-group
        v-model="cardType"
        style="margin-bottom: 30px;"
        size="small"
        @change="radioClick"
      >
        <el-radio-button label="0">会员卡</el-radio-button>
        <el-radio-button label="1">加油卡</el-radio-button>
        <el-radio-button label="3">车队卡</el-radio-button>
      </el-radio-group>
      <div class="table_box" v-if="false">
        <el-table
          :data="discountList"
          size="small"
          :header-cell-style="setHeader"
        >
          <el-table-column
            label="适用卡项"
            prop="show_card"
            width="120px"
          ></el-table-column>
          <el-table-column
            label="参与对象"
            prop="show_user"
            width="120px"
          ></el-table-column>
          <el-table-column label="优惠项">
            <template slot-scope="scope">
              <div
                class="recharge_item"
                v-for="(item, index) in scope.row.rule"
                :key="index"
              >
                <div class="item_index">第{{ index + 1 }}档</div>
                <div class="item_content">
                  <div class="content_amount">
                    充值 {{ item.charge_money }} 元
                    <span style="margin:0 5px 0 20px">送</span>
                  </div>
                  <div class="content_give">
                    <div v-if="item.money_status == '1'">
                      {{ item.money }}元余额
                    </div>
                    <div v-if="item.point_status == '1'">
                      {{ item.point }}点积分
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)"
                >编辑</el-button
              >
              <el-button type="text" @click="delItem(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="list_box" v-for="item in discountList" :key="item.id">
        <div class="text_line dflex">
          <div class="flex1">适用卡项：{{ item.show_card }}</div>
          <div>
            <el-button size="small" @click="editItem(item.id)"
              >编辑规则</el-button
            >
            <el-button type="danger" size="small" @click="delItem(item.id)"
              >删除</el-button
            >
          </div>
        </div>
        <div class="text_line">
          参与对象：{{ item.participant }}
        </div>
<!--        <div class="text_line">-->
<!--          活动时间：{{ item.is_forever==1?'长期有效':`${item.start_time}至${item.end_time}` }}-->
<!--        </div>-->
        <div class="table_line">
          <el-table
            :header-cell-style="setHeader"
            size="small"
            :data="item.rule"
            border
          >
            <el-table-column
              label="档位"
              type="index"
              width="70px"
              align="center"
            ></el-table-column>
            <el-table-column
              label="充值金额"
              prop="charge_money"
              align="center"
            ></el-table-column>
            <el-table-column
              label="赠送余额"
              prop="money"
              align="center"
            ></el-table-column>
            <el-table-column
              label="赠送积分"
              prop="point"
              align="center"
            ></el-table-column>
            <el-table-column
              label="赠送优惠券"
              prop="show_coupon"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              label="赠送实物"
              prop="good_name"
            ></el-table-column>
          </el-table>
        </div>
        <div class="text_line">规则描述：{{ item.des }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { rechargeDel, rechargeList } from "@/api/vip";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      cardType: "0",
      page_id: "",
      discountList: [],
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      joinMember: "全部成员"
    };
  },
  mounted() {
    this.getData();
    this.page_id = this.$route.params.id;
  },
  methods: {
    //
    radioClick(val) {
      console.log("radio", val);
      this.getData();
    },
    getData() {
      //获取已有优惠数据
      rechargeList({
        token: this.token,
        app_id: this.app_id,
        card_type: this.cardType
      }).then(res => {
        if (res.code == 200) {
          this.discountList = res.data;
          this.discountList.forEach(item => {
            if(item.rule){
              item.rule.forEach(n => {
                n.show_coupon = n.coupon_data.map(x => x.title).join(",");
              });
            }
            item.show_card = item.user_level.map(x => x.name).join(",");
          });
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `rechange-set`
      });
    },
    editItem(id) {
      this.$router.push({ path: "rechange-set", query: { eid: id } });
    },
    delItem(i) {
      console.log(i);
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          rechargeDel(data).then(res => {
            if (res.code == 200) {
              this.getData();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message(res.msg);
            }
          });
        })
        .catch();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  overflow: auto;
  min-width: 900px;
  // background:rgba(240,242,245,1);
  .inner_content {
    background: #fff;
    height: 100%;
    .header {
      line-height: 60px;
    }
    .table_box {
      padding-bottom: 20px;
      .table_title_line {
        margin: 15px 0;
        .title_name {
          font-weight: 500;
          border: 1px solid #ddd;
          border-radius: 3px;
          display: inline-block;
          margin-left: 15px;
          padding: 1px 10px;
        }
      }
    }
    .recharge_item {
      display: flex;
      background: #fafafa;
      border-radius: 5px;
      padding: 5px 15px;
      font-size: 14px;
      .item_index {
        margin-right: 20px;
      }
      .item_content {
        flex: 1;
        display: flex;
        .content_amount {
          margin-right: 1px;
        }
        .content_give {
          flex: 1;
          div {
            margin-bottom: 3px;
          }
        }
      }
    }
    .list_box {
      border: 10px solid #f5f5f5;
      background: #fff;
      border-radius: 5px;
      padding: 10px 15px;
      margin-bottom: 10px;
      font-size: 14px;
      .text_line {
        line-height: 32px;
      }
      .table_line {
        margin: 12px 0;
      }
      .border_btm {
        border-bottom: 1px solid #fafafa;
      }
      .dflex {
        display: flex;
        .flex1 {
          flex: 1;
        }
      }
    }
  }
}
// 通用样式
.flex {
  display: flex;
  // align-items: center;
  padding: 10px 0px;
  .flex1 {
    flex: 1;
  }
}
</style>
